'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'chevron-up';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f077';
var svgPathData = 'M256.3 82.7l22.6 22.6 214.6 214.6-45.3 45.3-22.6-22.6-169.4-169.4-169.4 169.4-22.6 22.6-45.3-45.3 22.6-22.6 192-192 22.6-22.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChevronUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;